"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionList = void 0;
const Flag_1 = require("@opsbase/lib-issue/Flag");
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useDimensions_1 = __importDefault(require("@opsbase/react-hooks/useDimensions"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const Columns_1 = __importDefault(require("@opsbase/web-layout/Columns"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Radio_1 = __importDefault(require("@opsbase/web-ui/Radio"));
const react_1 = __importStar(require("react"));
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
function OpPerformQuestionList(props) {
    var _a;
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const [paneRef, paneDims] = (0, useDimensions_1.default)();
    const noOfCols = Math.max(Math.floor(paneDims.width / 210), 1);
    const values = `${(_a = answer.value) !== null && _a !== void 0 ? _a : ''}`.split(',');
    const multi = rule.allowMultiSelect;
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const handleClick = (0, useCallforward_1.default)(value => () => {
        // Toggle Off
        const textValue = `${value !== null && value !== void 0 ? value : ''}`;
        if (values.indexOf(textValue) >= 0) {
            if (multi) {
                doChangeAnswer({ value: values.filter(v => v !== textValue).join(',') });
            }
            else {
                doChangeAnswer({ value: '' });
            }
        }
        // Toggle On
        else {
            if (multi) {
                doChangeAnswer({ value: [...values, textValue].filter(v => !!v).join(',') });
            }
            else {
                doChangeAnswer({ value: textValue });
            }
        }
        forceUpdate();
    }, [doChangeAnswer, forceUpdate, multi, values]);
    return (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({ ref: paneRef }, props, { disableChildren: viewMode }),
            react_1.default.createElement(Columns_1.default, { noOfCols: noOfCols, padding: true }, (_a = rule.options) === null || _a === void 0 ? void 0 : _a.map((o, idx) => (react_1.default.createElement(Option, { key: 'option' + idx, option: o, checked: values.indexOf(o.value.toString()) >= 0, onClick: handleClick(o.value), multi: multi }))))));
    }, [paneRef, props, viewMode, noOfCols, rule, values, handleClick, multi]);
}
exports.OpPerformQuestionList = OpPerformQuestionList;
exports.default = OpPerformQuestionList;
function Option(props) {
    const { option, checked, onClick, multi } = props;
    const color = (0, Flag_1.flagColor)(option.flag);
    const [label] = (0, useAltForSelfLang_1.default)(option.label, option.labelAlt);
    return (0, react_1.useMemo)(() => multi ? (react_1.default.createElement(Checkbox_1.default, { color: color, label: label, checked: checked, onChange: onClick })) : (react_1.default.createElement(Radio_1.default, { color: color, label: label, checked: checked, onClick: onClick })), [checked, color, label, multi, onClick]);
}
